
export const ActivityRightBarSkeleton = () => (
  <div className={`box_detail box_shdow activity_question activity-element`}>
    <div className="d-flex justify-content-between">
      <h4 className="content-skeleton m-0 mb-1" style={{ height: "13px", width: "16%" }}>{""}</h4>
      <div className="p-relative d-flex  align-items-center">
        <div className="p-relative">
          <div className="profile_placeholder"></div>
        </div>
      </div>
    </div>
    <div className="d-flex justify-content-between mt-1 mb-1">
      <h4 className="content-skeleton m-0" style={{ height: "15px", width: "16%" }}>{""}</h4>
      <h4 className="content-skeleton m-0" style={{ height: "14px", width: "12%" }}>{""}</h4>
    </div>
    <h4 className="event-less content-skeleton m-0 mt-2 mb-2" style={{ height: "20px", width: "30%"}}></h4>
    <div className="lh_16 event-less activity-description">
      <h4 className="content-skeleton m-0 mt-1" style={{ height: "12px", width: "50%"}}></h4>
    </div>
    <div className="d-flex justify-content-between align-items-center mt-3">
      <h4 className="content-skeleton m-0 mb-2" style={{ height: "12px", width: "14%"}}></h4>
      <h4 className="content-skeleton m-0" style={{ height: "18px", width: "10%"}}></h4>
    </div>
  </div>
);
